import Project from './project'

export default Project
